import {axiOrders, GetListOutput, GetListParams} from '@shared/api';
import {validateData} from '@shared/utils';
import {Order, OrderFullInfo, OrderItem} from '../types';
import {
  orderFullInfoV8nSchema,
  v8nSchemaOfGetOrderItemsResponse,
  v8nSchemaOfGetUserOrdersResponse,
} from './backendSchemas';
import {
  GetOrderItemsResponse,
  GetUserOrdersResponse,
  OrderFullInfoOnBackend,
} from './backendTypes';
import {
  mapOrderFromBackend,
  mapOrderFullInfoFromBackend,
  mapOrderItemFromBackend,
} from './dataMappers';

export interface GetUserOrdersParams extends GetListParams {
  userId: string;
}

export const getUserOrders = async ({
  userId,
  page,
  pageSize,
}: GetUserOrdersParams): Promise<GetListOutput<Order>> => {
  const response = await axiOrders.get<GetUserOrdersResponse>(
    `/admin/users/${userId}/orders`,
    {
      params: {
        page,
        per_page: pageSize,
      },
    },
  );

  const data = response.data;

  validateData(data, v8nSchemaOfGetUserOrdersResponse, 'getUserOrders');

  const {
    total,
    total_pages,
    array,
    page: pageFromBackend,
    per_page: pageSizeFromBackend,
  } = data;

  return {
    page: pageFromBackend,
    pageSize: pageSizeFromBackend,
    total,
    totalPages: total_pages,
    items: array.map(item => mapOrderFromBackend(item)),
  };
};

export const getOrderFullInfo = async (
  orderId: string,
): Promise<OrderFullInfo> => {
  const response = await axiOrders.get<OrderFullInfoOnBackend>(
    `/admin/orders/${orderId}`,
  );

  const data = response.data;

  validateData(data, orderFullInfoV8nSchema, 'getOrderFullInfo');

  return mapOrderFullInfoFromBackend(data);
};

export type GetOrdersParams = GetListParams;

export const getOrders = async ({
  page,
  pageSize,
}: GetOrdersParams): Promise<GetListOutput<Order>> => {
  const response = await axiOrders.get<GetUserOrdersResponse>('/admin/orders', {
    params: {
      page,
      per_page: pageSize,
    },
  });

  const data = response.data;

  validateData(data, v8nSchemaOfGetUserOrdersResponse, 'getOrders');

  const {
    total,
    total_pages,
    array,
    page: pageFromBackend,
    per_page: pageSizeFromBackend,
  } = data;

  return {
    page: pageFromBackend,
    pageSize: pageSizeFromBackend,
    total,
    totalPages: total_pages,
    items: array.map(item => mapOrderFromBackend(item)),
  };
};

export interface GetOrderItemsParams extends GetListParams {
  orderId: string;
}

export const getOrderItems = async ({
  orderId,
  page,
  pageSize,
}: GetOrderItemsParams): Promise<GetListOutput<OrderItem>> => {
  const response = await axiOrders.get<GetOrderItemsResponse>(
    `/admin/orders/${orderId}/items`,
    {
      params: {
        page,
        per_page: pageSize,
      },
    },
  );

  const data = response.data;

  validateData(data, v8nSchemaOfGetOrderItemsResponse, 'getOrderItems');

  const {
    total,
    total_pages,
    array,
    page: pageFromBackend,
    per_page: pageSizeFromBackend,
  } = data;

  return {
    page: pageFromBackend,
    pageSize: pageSizeFromBackend,
    total,
    totalPages: total_pages,
    items: array.map(item => mapOrderItemFromBackend(item)),
  };
};

export interface GetEventOrdersParams extends GetListParams {
  eventId: string;
}

export const getEventOrders = async ({
  eventId,
  page,
  pageSize,
}: GetEventOrdersParams): Promise<GetListOutput<Order>> => {
  const response = await axiOrders.get<GetUserOrdersResponse>(
    `/admin/events/${eventId}/orders`,
    {
      params: {
        page,
        per_page: pageSize,
      },
    },
  );

  const data = response.data;

  validateData(data, v8nSchemaOfGetUserOrdersResponse, 'getEventOrders');

  const {
    total,
    total_pages,
    array,
    page: pageFromBackend,
    per_page: pageSizeFromBackend,
  } = data;

  return {
    page: pageFromBackend,
    pageSize: pageSizeFromBackend,
    total,
    totalPages: total_pages,
    items: array.map(item => mapOrderFromBackend(item)),
  };
};
